import { ReactNode, useCallback } from 'react';

import { Intent, ToasterContext } from '@varicent/components';

import { useContextSafe } from './useContextSafe';

const toastIcons = {
  success: 'tick-circle',
  warning: 'warning-sign',
  primary: 'info-sign',
  danger: 'info-sign',
  none: 'info-sign'
} as const;

const useShowToast = () => {
  const toast = useContextSafe(ToasterContext);

  const vdsShowToast = useCallback(
    (message: ReactNode, intent: Intent, timeout?: number) => {
      toast.show({ message, intent, icon: toastIcons[intent], timeout });
    },
    [toast.show]
  );

  return vdsShowToast;
};

export default useShowToast;
